<template>
    <div class="marginCon">
        <Card>
            <!-- 搜索 -->
            <div class="search-div">
                <DatePicker class="input-div" type="datetimerange" @on-change='selectT' format="yyyy-MM-dd HH:mm" :placeholder="$t('selectPlaceholder')" style="width: 300px"></DatePicker>
                <Button type="info" @click="searchItem"  icon="ios-search" style="width:96px;border-radius: 6px;">{{$t('search')}}</Button>
            </div>
    
            <div v-if="offModel">
                <Table max-height='770' style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
            </div>
        </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        name: "firmwareVersion",
        components: {
        },
        data(){
            return{
                loading: true,
                offModel: true,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                tableList:{
                    tableData:[]
                },
                searchObj:{
                    startTime:'',
                    endTime:'',
                }
               
               
            }
        },
        computed:{
            ...mapState(['selectId']),
            titleName(){
                return [
                    {
                        title:this.$t('accountHistory.titleName.id'),
                        'title-zh-CN':'交易编号',
                        'title-en-US':'Id',
                        key: 'id',
                        minWidth: 110,
                        sortable: true,
                        tree: true
                    },
                    {
                        title:this.$t('accountHistory.titleName.transTime'),
                        'title-zh-CN':'交易时间',
                        'title-en-US':'Transaction time',
                        key: 'transTime',
                        minWidth: 180,
                        render:(h, params)=>{
                            // let stext = moment(params.row.transTime*1+8*60*60*1000).format('YYYY-MM-DD HH:mm:ss')
                            let stext = moment(params.row.transTime*1).format('YYYY-MM-DD HH:mm:ss')
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('accountHistory.titleName.balance'),
                        'title-zh-CN':'账户余额',
                        'title-en-US':'Balance',
                        key: 'balance',
                        minWidth: 180
                        
                    },
                    {
                        title:this.$t('accountHistory.titleName.transAmount'),
                        'title-zh-CN':'交易金额',
                        'title-en-US':'Transaction amount',
                        key: 'transAmount',
                        sortable: true,
                        minWidth: 190
                        
                    },
                     {
                        title:this.$t('accountHistory.titleName.postTradeBalance'),
                        'title-zh-CN':'交易后余额',
                        'title-en-US':'Balance after transactio',
                        key: 'postTradeBalance',
                        minWidth: 210
                    },
                   {
                        title:this.$t('accountHistory.titleName.type'),
                        'title-zh-CN':'交易类型',
                        'title-en-US':'Transaction type',
                        key: 'type',
                        minWidth: 280,
                        render:(h, params)=>{
                             let obj = {'1':this.$t('selectList.transactionType.Recharge'),'2':this.$t('selectList.transactionType.SMS'),3:this.$t('selectList.transactionType.other'),4:this.$t('selectList.transactionType.Activate')}
                             let stext = obj.hasOwnProperty(params.row.type)?obj[params.row.type] : params.row.type
                             return h('div',stext || '')
                        }
                    }
                   
                ]

            } ,
        },
        created (){
            this.getData()
        },
    
        methods: {
            selectT(val){
               this.searchObj.startTime = val[0]?new Date(val[0]).getTime():""
               this.searchObj.endTime = val[1]?new Date(val[1]).getTime():""
            },
            searchItem(){
                this.loading = true
                this.page.current = 1
                this.page.pageSize = 15
                this.getData()
            },
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        dealerId:this.selectId,
                        ...this.searchObj
                    }
                }
                this.axios.post(this.config.urlArray.translogList,getData.params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{
                        let resData = result.data.data.transList
                        //处理数组
                        if(resData){
                            this.tableList.tableData = resData  //渲染数据
                            this.page.total = result.data.data.meta.count
                            this.loading = false
                        }
                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            }
        }
    }
</script>



